/**
 * 工作协同消息
 * Bai.Zhiming
 * 2019-6-25
 */
angular.module("collaborationMessageModule", []).
controller("collaborationMessageCtrl", ['$scope', 'trsHttpService', 'trsspliceString', '$q', 'messageCenterService', 'modalDialog', 'msgService', '$rootScope',
    function($scope, trsHttpService, trsspliceString, $q, messageCenterService, modalDialog, msgService, $rootScope) {
        initStatus();
        tabIsShow().then(function(){
            queryTypeCount();
            initData();
        });
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                tabList: [
                    { name: '全部', value: 'all', message: '', type: 0 },
                    { name: '待审稿件', value: 'trialDraft', message: '', type: 1 },
                    { name: '传稿', value: 'transferDraft', message: '', type: 2 },
                    { name: '退稿', value: 'rejectDraft', message: '', type: 3 },
                    { name: '撤稿', value: 'withdrawDraft', message: '', type: 4 },
                    { name: '取稿', value: 'takeDraft', message: '', type: 5 },
                    { name: '个人稿已签发', value: 'signedPersonal', message: '', type: 6 },
                    { name: '任务指派', value: 'taskAssignment', message: '', type: 7 },
                    { name: '任务审核', value: 'taskTrial', message: '', type: 8 },
                    { name: '报题审核通过', value: 'reportApproved', message: '', type: 9 },
                    { name: '报题审核', value: 'reportTrail', message: '', type: 10 },
                    { name: '待审广告', value: 'adPend', message: '', type: 11 },
                    // { name: '微信群发', value: 'wechat', message: '', type: 12 },
                    // { name: '共享稿库', value: 'shareLibrary', message: '', type: 13 }
                ],
                typeArr: [], //type值 集合
                hotLists: {
                    page: {
                        'pn': 1,
                        'PAGESIZE': 20,
                        'PAGECOUNT': 0,
                        'ITEMCOUNT': 0,
                        'startpage': 1,
                    },
                    status: {
                        'jumpToPageNum': 1,
                        'startpage': 1
                    }
                },
                readType:msgService.readType,
            };
            $scope.data = {
                selectedArray: [],
                items: []
            };
        }
        /**
         * [tabIsShow description] 查询工作协同消息标签是否展示
         * 
         */
        function tabIsShow(){
            let defer = $q.defer();
            let params = {
                serviceid: 'messageConfig',
                method: 'teamworkconfig',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(),params,'get').then(function(data){
                let cnt = 0;
                if(data.issuccess=="true"){
                    data.data["待审稿件提醒"] == 1 ? $scope.status.tabList[1].isShow = true : cnt++; 
                    data.data["传稿提醒"] == 1 ? $scope.status.tabList[2].isShow = true : cnt++;
                    data.data["退稿提醒"] == 1 ? $scope.status.tabList[3].isShow = true : cnt++;
                    data.data["撤稿提醒"] == 1 ? $scope.status.tabList[4].isShow = true : cnt++;
                    data.data["取稿提醒"] == 1 ? $scope.status.tabList[5].isShow = true : cnt++;
                    data.data["个人创作稿件在渠道已签发提醒"] == 1 ? $scope.status.tabList[6].isShow = true : cnt++;
                    data.data["任务指派提醒"] == 1 ? $scope.status.tabList[7].isShow = true : cnt++;
                    data.data["任务审核提醒"] == 1 ? $scope.status.tabList[8].isShow = true : cnt++;
                    data.data["报题审核通过提醒"] == 1 ? $scope.status.tabList[9].isShow = true : cnt++;
                    data.data["报题审核提醒"] == 1 ? $scope.status.tabList[10].isShow = true : cnt++;
                    data.data["待审广告提醒"] == 1 ? $scope.status.tabList[11].isShow = true : cnt++;
                    if(cnt==11){
                        $scope.status.tabList[0].isShow = false;
                    }
                    else{
                        $scope.status.tabList[0].isShow = true;
                    }
                }
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            $scope.status.selectedTab = $scope.status.tabList[0];
            let typeStr = trsspliceString.spliceString($scope.status.tabList, 'type', ',');
            $scope.status.typeArr = typeStr.split(",");
            getCurrentLoginUser().then(() => {
                getData();
            });
        }
        /**
         * [isShowForType description] 根据type是否显示
         * return Boolean
         */
        $scope.isShowForType = function(type) {
            var flag = false;
            if ($scope.status.typeArr.indexOf(type) > -1) {
                flag = true;
            }
            return flag;
        };
        /**
         * [getCurrentLoginUser description] 获取当前登录的用户信息
         * @return {[type]} [description]
         */
        function getCurrentLoginUser() {
            var deferred = $q.defer();
            var userParams = {
                serviceid: "mlf_extuser",
                methodname: "findUserInfo"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, "post").
            then(function(data) {
                $scope.data.userInfo = data[0];
                deferred.resolve(data);
            });
            return deferred.promise;
        }
        /**
         * [getAllMessages description] 获取全部消息数据
         * @return {[type]} [description]p
         */
        function getAllMessages() {
            let defer = $q.defer();
            let typeItems = [];
            angular.forEach($scope.status.tabList,function(item){
                if(item.isShow){
                    typeItems.push(angular.copy(item));
                }
            });
            var typeids = trsspliceString.spliceString(typeItems, 'type', ',');
            let params = {
                serviceid: 'message',
                method: 'queryallmsg',
                socketid: $scope.data.userInfo.ID,
                fromtype: 1,
                pagesize: $scope.status.hotLists.page.PAGESIZE,
                pagenumber: $scope.status.hotLists.page.startpage,
                opertype: typeids,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                updataArr(data)
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getTypeMessages description] 获取不同类型消息数据
         * @param  {[type]} type [description] 类型
         * @return {[type]}      [description]
         */
        function getTypeMessages(type) {
            let defer = $q.defer();
            let params = {
                serviceid: 'message',
                method: 'msgtypelist',
                socketid: $scope.data.userInfo.ID,
                opertype: type,
                pagesize: $scope.status.hotLists.page.PAGESIZE,
                pagenumber: $scope.status.hotLists.page.startpage,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                updataArr(data)
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * updata 接口请求数据后 更新数据
         */
        function updataArr(data) {
            $scope.data.items = data.data.content;

            $scope.status.hotLists.page.pn = data.data.number + 1;
            $scope.status.hotLists.page.PAGESIZE = data.data.size;
            $scope.status.hotLists.page.PAGECOUNT = data.data.totalPages;
            $scope.status.hotLists.page.ITEMCOUNT = data.data.totalElements;
        }
        /**
         * [querytypecount description]根据不同分类查询消息数目
         */
        function queryTypeCount() {
            let defer = $q.defer();
            let typeItems = [];
            angular.forEach($scope.status.tabList,function(item){
                if(item.isShow){
                    typeItems.push(angular.copy(item));
                }
            });
            var typeids = trsspliceString.spliceString(typeItems, 'type', ',');
            let params = {
                typeids: typeids,
                serviceid: "message",
                method: "querytypecount"
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                let items = data.data;
                $scope.status.tabList.forEach((tab) => {
                    items.forEach((item) => {
                        if (tab.type == item.type) {
                            tab.message = item.count > 99 ? '99+' : item.count;
                        }
                    })
                })
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [tabSwitch description] tab切换
         * @param  {[type]} tab [description] tab
         * @return {[type]}     [description]
         */
        $scope.tabSwitch = function(tab) {
            if ($scope.status.selectedTab.value == tab.value) {
                return;
            }
            $scope.status.selectedTab = tab;
            clearPage();
            getData();
            queryTypeCount();
        }
        /**
         * [returnType description]返回来源
         */
        $scope.returnType = function(type) {
            $scope.status.tabList.forEach((item, index) => {
                if (item.type == type) {
                    return item.name
                }
            })
        }
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.pn;
            $scope.status.hotLists.page.startpage = $scope.status.hotLists.page.pn;
            getData();
        };
        $scope.jumpToPage = function() {
            if ($scope.status.hotLists.status.jumpToPageNum > $scope.status.hotLists.page.PAGECOUNT) {
                $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.PAGECOUNT;
            }
            if ($scope.status.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.status.hotLists.status.jumpToPageNum))) {
                modalDialog.alertType("请输入合法的页码", "", "warning", false);
                return;
            }
            $scope.status.hotLists.page.startpage = $scope.status.hotLists.status.jumpToPageNum;
            getData();
        };
        /**
         * [clearPage description] 还原page信息
         */
        function clearPage() {
            $scope.status.hotLists = {
                page: {
                    'pn': 1,
                    'PAGESIZE': 20,
                    'PAGECOUNT': 0,
                    'ITEMCOUNT': 0,
                    'startpage': 1,
                },
                status: {
                    'jumpToPageNum': 1,
                    'startpage': 1
                }
            }
        }
        /**
         * [getData description] 执行获取数据函数
         */
        function getData() {
            $scope.data.selectedArray = [];
            if ($scope.status.selectedTab.value == 'all') {
                getAllMessages();
            } else {
                getTypeMessages($scope.status.selectedTab.type);
            }
        }
        /**
         * [isChecked description] 判断数据是否选中
         * @param  {[type]}  item [description] 数据
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            return $scope.data.selectedArray.some((_item) => {
                return _item.messageid == item.messageid;
            });
        }
        /**
         * [selectItem description] 选中/取消选中数据
         * @param  {[type]} item [description] 数据
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(item) {
            if ($scope.isChecked(item)) {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
        }
        /**
         * [selectAll description] 全选/取消全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.items.length > 0 && $scope.data.items.length == $scope.data.selectedArray.length ? [] : [].concat($scope.data.items);
        }
        /**
         *[requestData description] 标记为已读
         * @param  {[type]}  [description] 类型（0:已选数据标记为已读 1:全部标记为已读）
         * @return {[type]}    [description]
         */
        $scope.markAsRead = function(type) {
            var msgsocketrelids = trsspliceString.spliceString($scope.data.selectedArray, 'msgsocketrelid', ',');
            if (type == 0) {
                messageCenterService.messageCenterReadNotices(msgsocketrelids, !!type, $scope.data.userInfo.ID, $scope.status.selectedTab.type).then((data) => {
                    getData();
                    $rootScope.$broadcast('updateMessage', 'update')
                    modalDialog.alertType("设置成功", "", "success", false);
                })
            } else {
                msgsocketrelids = trsspliceString.spliceString($scope.data.items, 'msgsocketrelid', ',');
                messageCenterService.messageCenterReadNotices(msgsocketrelids, !!type, $scope.data.userInfo.ID, $scope.status.selectedTab.type).then((data) => {
                    getData();
                    $rootScope.$broadcast('updateMessage', 'update')
                    modalDialog.alertType("设置成功", "", "success", false);
                })
            }
            $scope.data.selectedArray = [];
        }
        /**
         * [gotoDetail description] 稿件编辑页地址
         * @param  {[item]}  [description] 
         */
        $scope.gotoDetail = function(item) {
            if (
                item.opertype == 1 ||
                item.opertype == 2 ||
                item.opertype == 3 ||
                item.opertype == 4
            ) {
                msgService.gotoDetail(item).then((data) => {
                    var url = data.data.editurl;
                    setTimeout(() => {
                        getData();
                        $rootScope.$broadcast('updateMessage', 'update')
                    }, 1000)
                    window.open(url);
                });
            }
        }
        /**
         * [handleTime description] 处理日期格式
         * @param  {[type]} item [description] 条目信息
         * @param  {[type]} attribute [description] 需要处理的属性
         * @return {[type]}      [description]
         */
        $scope.handleTime = function(item, attribute) {
            item[attribute] = item[attribute].replace(/ /, "<br/>");
        }
    }
]);